import {IconDeviceMobile} from "@tabler/icons-react";
import PropTypes from "prop-types";
import {useEffect, useState} from "react";
import PaykuImg from "../../assets/images/logoPayku.webp";
import BinanceImg from "../../assets/images/modal-icons/binance-exchange.svg";
import useCurrencyStore from "../../store/useCurrency.store";
import BinanceWithdrawal from "./BinanceWithdrawal";
import PaykuWithdrawal from "./PaykuWithdrawal";
import styles from "./WithdrawalMethods.module.css";
import WithdrawalSteps from "./WithdrawalSteps";

const WithdrawalMethods = ({setWithdrawalModalWidth, closeModal}) => {
  const [selected, setSelected] = useState(null); // null | 'pagoMovil' | 'binance' | 'payku'
  const {selectedCurrency} = useCurrencyStore();

  // Cancel and reset everything (used for Cancelar in all flows)
  const handleCancelAll = () => {
    setSelected(null);
    if (typeof closeModal === "function") closeModal();
  };

  // Set modal width based on selected flow
  useEffect(() => {
    if (selected === "pagoMovil") {
      setWithdrawalModalWidth?.("978px");
    } else if (selected === "binance") {
      setWithdrawalModalWidth?.("678px");
    } else if (selected === "payku") {
      setWithdrawalModalWidth?.("878px");
    } else {
      setWithdrawalModalWidth?.("678px");
    }
  }, [selected, setWithdrawalModalWidth]);

  if (selected === "pagoMovil") {
    return (
      <WithdrawalSteps
        onBack={() => setSelected(null)}
        onCancel={handleCancelAll}
      />
    );
  }
  if (selected === "binance") {
    return (
      <BinanceWithdrawal
        onBack={() => setSelected(null)}
        onCancel={handleCancelAll}
      />
    );
  }

  if (selected === "payku") {
    return (
      <PaykuWithdrawal
        onBack={() => setSelected(null)}
        onCancel={handleCancelAll}
      />
    );
  }

  return (
    <div style={{textAlign: "center", padding: "0 2rem"}}>
      <h2 className={styles.withdrawal_title}>¿Cómo quieres retirar?</h2>
      <div className={styles.withdrawal_option_logo_container}>
        {selectedCurrency?.id !== "CLP" && (
          <div onClick={() => setSelected("pagoMovil")}>
            <IconDeviceMobile
              size={28}
              color="var(--text-primary)"
            />
            <span className={styles.withdrawal_option_label}>Pago Móvil</span>
          </div>
        )}
        <div>
          <img
            src={BinanceImg}
            alt="Binance"
            className={styles.withdrawal_option_logo_binance}
            onClick={() => setSelected("binance")}
          />
        </div>
        {selectedCurrency?.id === "CLP" && (
          <div>
            <img
              src={PaykuImg}
              alt="Payku"
              className={styles.withdrawal_option_logo_payku}
              onClick={() => setSelected("payku")}
            />
          </div>
        )}
      </div>
    </div>
  );
};
WithdrawalMethods.propTypes = {
  setWithdrawalModalWidth: PropTypes.func,
  closeModal: PropTypes.func,
};

export default WithdrawalMethods;
